import { Component, OnInit } from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'particle-progressive-block-dialog',
  templateUrl: './progressive-block-dialog.component.html',
  styleUrls: ['./progressive-block-dialog.component.scss']
})
export class ProgressiveBlockDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  constructor(public router: Router,
              public dialog: MatDialog) {
    console.log(this.data);
  }

  ngOnInit() {
  }
  onOkClicked(): boolean {
    return true;
  }
}
